import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import Logo from '../../assets/logo.png';

export default class Loading extends Component {
  render() {
    return (
      <div className={css(styles.container) + ' animate-flicker'}>
        <img src={Logo} className={css(styles.image)} />
        <h1 className={css(styles.loading_text)}>Loading. Just a sec.</h1>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100vw',
    height: window.innerHeight - (Theme.navigation.height),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  image: {
    display: 'block',
    marginBottom: 20,
    width: 250,
  },
  loading_text: {
    display: 'block',
    fontFamily: Theme.fontFamily,
    fontWeight: '900',
    color: Theme.black,
    fontSize: 20,
    lineHeight: '64px',
  }
})



// WEBPACK FOOTER //
// ./src/components/Loading/index.js